import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import { generateQueryString } from "../../core/utility/utility";
import { getViewShipmentDataDictionary as globalViewShipmentDataDictionary } from "@core/global/global-view-shipment-handling";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { getIntelUrl } from "@utils/intelUrl";

const redirectionUrls = {
  argentina_export: "argentina-search-export",
  peru_export: "peru-search-export",
  russia_import: "russia-search-import-mirror",
  russia_export: "russia-search-export-mirror",
  russia_nm_import: "russia-search-import",
  russia_nm_export: "russia-search-export",
  china_import: "china-search-import-mirror",
  china_export: "china-search-export-mirror",
  singapore_import: "singapore-search-import-mirror",
  singapore_export: "singapore-search-export-mirror",
  uae_import: "uae-search-import-mirror",
  uae_export: "uae-search-export-mirror",
  malaysia_import: "malaysia-search-import-mirror",
  malaysia_export: "malaysia-search-export-mirror",
  thailand_import: "thailand-search-import-mirror",
  thailand_export: "thailand-search-export-mirror",
  turkey_import: "turkey-search-import-mirror",
  turkey_export: "turkey-search-export-mirror",
  indonesia_import: "indonesia-search-import-mirror",
  indonesia_export: "indonesia-search-export-mirror",
  "indonesia nm_import": "indonesia-search-import-nm",
  "indonesia nm_export": "indonesia-search-export-nm",
  brazil_import: "brazil-search-import-mirror",
  brazil_export: "brazil-search-export-mirror",
  australia_import: "australia-search-import-mirror",
  australia_export: "australia-search-export-mirror",
  middleeast_import: "middle-east-search-import-mirror",
  middleeast_export: "middle-east-search-export-mirror",
  europe_import: "europe-search-import-mirror",
  europe_export: "europe-search-export-mirror",
  taiwan_import: "taiwan-search-import-mirror",
  taiwan_export: "taiwan-search-export-mirror",
  "saudi arabia_import": "saudi-arabia-search-import-mirror",
  "saudi arabia_export": "saudi-arabia-search-export-mirror",
  canada_import: "canada-search-import-mirror",
  canada_export: "canada-search-export-mirror",
  germany_import: "germany-search-import-mirror",
  germany_export: "germany-search-export-mirror",
  "hong kong_import": "hong-kong-search-import-mirror",
  "hong kong_export": "hong-kong-search-export-mirror",
  japan_import: "japan-search-import-mirror",
  japan_export: "japan-search-export-mirror",
  "south korea_import": "south-korea-search-import-mirror",
  "south korea_export": "south-korea-search-export-mirror",
  multicountry_import: "all-country-shipments",
};

const countriesType = {
  argentina_export: "ar_export",
  peru_export: "pe_export",
  russia_import: "ru_import",
  russia_export: "ru_export",
  runm_import: "runm_import",
  runm_export: "runm_export",
  "indonesia nm_import": "idnm_import",
  "indonesia nm_export": "idnm_export",
  "saudi arabia_import": "sa_import",
  "saudi arabia_export": "sa_export",
  "hong kong_import": "hk_import",
  "hong kong_export": "hk_export",
  "south korea_import": "kr_import",
  "south korea_export": "kr_export",
  "canada import": "ca_import",
  "canada export": "ca_export",
  "germany import": "de_import",
  "germany export": "de_export",
  "japan import": "jp_import",
  "japan export": "jp_export",
  "taiwan import": "tw_import",
  "taiwan export": "tw_export",
};

const ItemNumShipmentRedirect = ({ rowData, fieldDetails, countryName, countryType, selectedRowData, from }) => {
  const { isViewAll, value, requestId, requestNum } = { ...fieldDetails };
  const navigateUserToCountry = () => {
    let url = "";
    let data = "";
    if (countryName && countryType && requestId && requestNum && rowData[requestId] && rowData[requestNum]) {
      if (countryName.toLowerCase() === "multicountry".toLowerCase()) {
        data = globalViewShipmentDataDictionary(selectedRowData.cell.row.original.alias_data_source.toUpperCase())?.defaultKey?.redirectionID;
        data = data.split("s");
        data[data.length - 1] = "";
        data = data.join("");
        url = globalCountryDetailsDictionary[data].countryPathName;
      } else if (countryName.toLowerCase() === "global data") {
        url = "global-search";
        data = "global_import";
      } else {
        url = redirectionUrls[countryName.toLowerCase() + "_" + countryType.toLowerCase()];
        data = countriesType[countryName.toLowerCase() + "_" + countryType.toLowerCase()];
      }
      let queryParams = {
        redirectingFrom: "item-number",
        itemNumberId: rowData[requestId],
        itemNumber: rowData[requestNum],
        countryType: data,
      };
      url = url + "?" + generateQueryString(queryParams);
      if (from === "dashboard" && url) {
        window.location.href = getIntelUrl() + url;
      } else if (url) window.open(url);
    } else toast.error("Something went wrong. Please try again later !!!");
  };

  return (
    <span className="d-block bold-data">
      {rowData && fieldDetails && isViewAll && rowData[isViewAll] && value && rowData[value] ? (
        <>
          <span>{rowData[value]}</span>
          <span className="w-100 ml-2">
            <a className="btn-link trademo-link py-0" onClick={() => navigateUserToCountry()}>
              <u>View All</u>
            </a>
          </span>
        </>
      ) : rowData && fieldDetails && value && rowData[value] ? (
        <span className="w-100 m-0">{rowData[value]}</span>
      ) : (
        "NA"
      )}
    </span>
  );
};
export default withRouter(ItemNumShipmentRedirect);
